<div class="card grid" *ngIf="!activeItem?.disabled && !setupLoading">
    <div class="mt-2 ml-2 col-12">
        <app-ef-setup-inputs [selectedProject]="selectedProject" [isProjectOwnershipValid]="isProjectOwnershipValid"
            [filteredFormulations]="filteredFormulations" [geographies]="geographies"
            [currentUserName]="currentUserName"
            (onformulationSelectionChangeEvent)="onformulationSelectionChanged($event)"
            (onQueryFilterChangeEvent)="onFormulationFilterChanged($event)"
            (isSetupValidEvent)="validateSetupInfoInProject($event)"
            (onGeographySelectionChangeEvent)="onGeographyChanged()"></app-ef-setup-inputs>
    </div>
    <div class="mt-5 ml-2 col-8">
        <app-ef-setup-models-to-be-run [modelsLoading]="modelsLoading"
            [isProjectOwnershipValid]="isProjectOwnershipValid" [selectedProject]="selectedProject"
            [modelsToBeRun]="modelsToBeRun" [columnsDefinition]="columnDef"
            [modelsCollection]="modelsCollection"
            (areSetupModelsValidEvent)="validateSetupModelInProject($event)"
            (orderedModelsToBeRunRowData)="orderedModelsToBeRunRowData()"
            (selectedMoleculesChanged)="onSelectedMoleculesChanged($event)"></app-ef-setup-models-to-be-run>
    </div>
</div>

<app-loading class="flex align-items-center justify-content-center" *ngIf="setupLoading"></app-loading>
